export default "__VITE_ASSET__Qledqm76__"